import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import * as moment from 'moment';

@Component({
  selector: 'sc-counter-down',
  templateUrl: './counter-down.component.html',
  styleUrls: ['./counter-down.component.scss']
})
export class CounterDownComponent implements OnInit, AfterViewInit {

  disabled: boolean;

  @Input() end: string;

  @Output() ontimeout = new EventEmitter();

  @ViewChild('element', {static: false}) element;

  constructor() { }

  ngOnInit() {}

  ngAfterViewInit() {
    this.initializeClock(this.end);
  }

  getTimeRemaining(endtime) {
    const total = Date.parse(endtime) - Date.parse(`${ new Date() }`);
    const seconds = Math.floor((total / 1000) % 60);
    const minutes = Math.floor((total / 1000 / 60) % 60);
    const hours = Math.floor((total / (1000 * 60 * 60)) % 24);
    const days = Math.floor(total / (1000 * 60 * 60 * 24));
    
    return {
      total,
      days,
      hours,
      minutes,
      seconds
    };
  }
  
  initializeClock(endtime) {
    if (!endtime) {
      return;
    }

    endtime = moment(endtime).toDate();
    if (moment(endtime).isBefore(moment())) {
      this.disabled = true;
      this.ontimeout.emit(true);
      return;
    }

    const clock = this.element.nativeElement;
    const daysSpan = clock.querySelector('.days');
    const hoursSpan = clock.querySelector('.hours');
    const minutesSpan = clock.querySelector('.minutes');
    const secondsSpan = clock.querySelector('.seconds');
  
    const updateClock = () => {
      const t = this.getTimeRemaining(endtime);
  
      daysSpan.innerHTML = t.days;
      hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
      minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
      secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
  
      if (t.total <= 0) {
        this.ontimeout.emit(true);
        clearInterval(timeinterval);
      }
    }
  
    updateClock();
    const timeinterval = setInterval(updateClock, 1000);
  }
  
}
